import { ref } from 'vue'
import { defineStore } from 'pinia'
import { generateRandomString } from '@utils/helper.utils'

const useAlertStore = defineStore('alert', () => {
  const alerts = ref([])
  const alerts_bank = ref([])

  function pushAlert(alert) {
    return new Promise((resolve, reject) => {
      try {
        alert.id = generateRandomString(5)
        alert.show = true

        if (alerts.value.length < 3) {
          alerts.value.push(alert)
        } else {
          alerts_bank.value.push(alert)
        }

        if (alert.timeout) {
          setTimeout(() => {
            removeAlert(alert.id)
          }, alert.timeout * 1000)
        }
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  function removeAlert(alert_id) {
    for (let i = 0; i < alerts.value.length; i++) {
      const alert = alerts.value[i]

      if (alert.id === alert_id) {
        alerts.value.splice(i, 1)

        if (alerts_bank.value.length > 0) {
          alerts.value.push(alerts_bank.value[0])
          alerts_bank.value.splice(0, 1)
        }
        return true
      }
    }

    return false
  }

  const clear = () => {}

  return {
    alerts,
    pushAlert,
    removeAlert,
    clear,
  }
})

export default useAlertStore
